module.exports = __webpack_public_path__ + "img/30th Anniversary Logo Design 3.ea11b530.png";